import type { CaseLinksManufacturer } from './caseLinkLogos';

// Accepts a manufacturer slug or a raw Aligner Preference label; anything not naming
// Invisalign, missing included, shows Spark. Kept apart from the logos so node can test it.
export function caseLinksManufacturer(
    manufacturer: string | null | undefined
): CaseLinksManufacturer {
    return (manufacturer ?? '').toLowerCase().includes('invisalign') ? 'invisalign' : 'spark';
}
